/**
 *
 * @param data from time_ranges query
 * @return array with formatted time ranges
 */
const timeRangesAdapter = data => {
  return data.map(item => {
    return {
      name: item.name,
      slug: item.slug,
      start: item.start_time,
      end: item.end_time,
    };
  });
};

export { timeRangesAdapter };
